




































import { Component, Mixins, Prop } from 'vue-property-decorator'
import { IntlMixin } from 'vuemixins/intl_mixin'
import OzBaseDialog from 'library/v4/components/OzBaseDialog.vue'
import LocationServiceDark from 'images/location_services_dark.svg'
import LocationServiceLight from 'images/location_services_light.svg'
import { navigateTo } from 'bits/location'

@Component({ components: { OzBaseDialog } })
export default class LocationPermissionAlertDialog extends Mixins(IntlMixin) {
  @Prop() dir!: string
  @Prop() darkMode!: boolean
  @Prop() isWindows!: boolean
  @Prop() isOpen!: boolean

  get iconUrl(): string {
    return this.darkMode ? LocationServiceDark : LocationServiceLight
  }

  get title(): string {
    return this.isWindows ? this.__('Location Access') : this.__('Enable Location Services')
  }

  get body(): string[] {
    return this.isWindows
      ? [
          this.__('You may need to set the system permission for geolocation to work:'),
          '- ' + this.__('Open Start menu > Click the Settings icon (lower-left) > Privacy.'),
          '- ' + this.__('From the left-pane, select Location.'),
          '- ' + this.__(`Click the Change button below the text 'Location for this device is off'.`),
          '- ' + this.__('Select the switch to turn on.'),
        ]
      : [
          this.__('You may need to set the system permission for geolocation to work:'),
          '- ' + this.__('Open System Preferences > Security & Privacy > Privacy tab > Location Services.'),
          '- ' + this.__('Click the lock to make changes.'),
          '- ' + this.__('Find and check the box besides Padlet.'),
        ]
  }

  cancel(): void {
    this.$emit('cancel')
  }

  proceed(): void {
    navigateTo('https://padlet.helpdocs.io/l/en/article/21mfjn75un-how-do-i-turn-on-location-services-on-my-computer', {
      target: '_blank',
    })
    this.cancel()
  }
}
